import { lazyWithRecovery } from "../../lib/chunk-load-recovery/lazy-with-recovery";
import type { RouteObject } from "react-router-dom";

import { createAbacLoader } from "../../app/router/guards/loaders/abac.loader";
import { accountUpdateLoader } from "../../app/router/guards/loaders/account-update.loader";
import { CONFIRM_PHONE_NUMBER_TEXT } from "../../constants/commonStrings";
import { PHONE_NUMBER_CONFIRMATION_PATH, PROFILE_PATH, SERVICES_PATH } from "../../constants/env";
import { PaymentBackdrop } from "../../legacy/components/PaymentBackdrop/payment-backdrop";
import QuestionnaireHeader from "../../legacy/components/QuestionnaireStepper/QuestionnaireHeader";
import { QuestionnaireStepperLayout } from "../../legacy/components/QuestionnaireStepper/QuestionnaireStepperLayout";
import { PhoneNumberConfirmationHeader } from "../../legacy/components/SubscriptionPlan/components/phone-number-confirmation/phone-number-confirmation-header/phone-number-confirmation-header";
import { withSuspense } from "./utils/with-suspense";

const SorryPage = lazyWithRecovery(() => import("../../legacy/pages/Questionnaire/SorryPage"));
const ServicePageRequisites = lazyWithRecovery(() => import("../../legacy/pages/ServicePageRequisites"));
const AdditionalInfo = lazyWithRecovery(() => import("../../legacy/pages/ServiceRequest/AdditionalInfo"));
const PhoneNumberConfirmation = lazyWithRecovery(
  () =>
    import("../../legacy/components/SubscriptionPlan/components/phone-number-confirmation/phone-number-confirmation")
);

export function createQuestionnaireRoutes(): RouteObject[] {
  return [
    {
      path: "/questionnaire/sorry",
      loader: accountUpdateLoader,
      element: (
        <QuestionnaireStepperLayout header={<QuestionnaireHeader title="Questionario" closeButtonURL={PROFILE_PATH} />}>
          {withSuspense(<SorryPage />)}
        </QuestionnaireStepperLayout>
      ),
    },
    {
      path: `${SERVICES_PATH}/:id/requisites`,
      loader: accountUpdateLoader,
      element: (
        <PaymentBackdrop>
          <QuestionnaireStepperLayout header={<QuestionnaireHeader title="Conferma requisiti" />}>
            {withSuspense(<ServicePageRequisites />)}
          </QuestionnaireStepperLayout>
        </PaymentBackdrop>
      ),
    },
    {
      path: "/requested-services/:id/:questionnaireName",
      loader: createAbacLoader({ permission: { can: "readOne", model: "ServiceRequest" } }),
      element: (
        <QuestionnaireStepperLayout header={<QuestionnaireHeader />}>
          {withSuspense(<AdditionalInfo />)}
        </QuestionnaireStepperLayout>
      ),
    },
    {
      path: PHONE_NUMBER_CONFIRMATION_PATH,
      loader: accountUpdateLoader,
      element: (
        <QuestionnaireStepperLayout header={<PhoneNumberConfirmationHeader title={CONFIRM_PHONE_NUMBER_TEXT} />}>
          {withSuspense(<PhoneNumberConfirmation />)}
        </QuestionnaireStepperLayout>
      ),
    },
  ];
}
